module.exports = __webpack_public_path__ + "static/media/portfolio-6.8724f8ad.jpg";